import { render, staticRenderFns } from "./WitnessForm.vue?vue&type=template&id=53f2b7f6"
import script from "./WitnessForm.vue?vue&type=script&lang=ts"
export * from "./WitnessForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports